// src/pages/Auth/index.jsx
import React, { useState } from 'react';
import { Layout, Card, Form, Input, Button, Tabs, message, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import AppHeader from '../../components/header';
import AppFooter from '../../components/footer';
import './index.css';

const { Content } = Layout;
const { Title } = Typography;

const Auth = ({ onLogin, onRegister, loggedInUser, onLogout, aboutInfo }) => {
  const [activeTab, setActiveTab] = useState('login');
  const [loginForm] = Form.useForm();
  const [registerForm] = Form.useForm();

  // 处理登录
  const handleLogin = async (values) => {
    try {
      // 这里调用实际的登录API
      const result = await onLogin(values);
      if (result.success) {
        message.success('登录成功');
        loginForm.resetFields();
      } else {
        message.error(result.message || '登录失败');
      }
    } catch (error) {
      message.error('登录失败: ' + error.message);
    }
  };

  // 处理注册
  const handleRegister = async (values) => {
    if (values.password !== values.confirmPassword) {
      message.error('两次输入的密码不一致');
      return;
    }

    try {
      // 这里调用实际的注册API
      const result = await onRegister(values);
      if (result.success) {
        message.success('注册成功，请登录');
        setActiveTab('login');
        registerForm.resetFields();
      } else {
        message.error(result.message || '注册失败');
      }
    } catch (error) {
      message.error('注册失败: ' + error.message);
    }
  };

  // 切换标签页
  const onTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <Layout className="blog-layout">
      <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} aboutInfo={aboutInfo}/>
      
      <Content className="auth-content">
        <div className="auth-container">
          <Card className="auth-card">
            <div className="auth-header">
              <Title level={2} className="auth-title">用户认证</Title>
              <p className="auth-subtitle">欢迎来到我的博客</p>
            </div>
            
            <Tabs 
              defaultActiveKey="login" 
              onChange={onTabChange}
              centered
              className="auth-tabs"
            >
              <Tabs.TabPane tab="登录" key="login">
                <Form
                  form={loginForm}
                  name="login"
                  initialValues={{ remember: true }}
                  onFinish={handleLogin}
                  autoComplete="off"
                  layout="vertical"
                >
                  <Form.Item
                    label="用户名"
                    name="username"
                    rules={[{ required: true, message: '请输入用户名!' }]}
                  >
                    <Input 
                      prefix={<UserOutlined />} 
                      placeholder="请输入用户名" 
                      size="large" 
                    />
                  </Form.Item>

                  <Form.Item
                    label="密码"
                    name="password"
                    rules={[
                      { required: true, message: '请输入密码!' },
                      { min: 6, message: '密码至少需要6个字符!' }
                    ]}
                  >
                    <Input.Password 
                      prefix={<LockOutlined />} 
                      placeholder="请输入密码" 
                      size="large" 
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button 
                      type="primary" 
                      htmlType="submit" 
                      block 
                      size="large"
                      className="auth-submit-btn"
                    >
                      登录
                    </Button>
                  </Form.Item>
                </Form>
              </Tabs.TabPane>
              
              <Tabs.TabPane tab="注册" key="register">
                <Form
                  form={registerForm}
                  name="register"
                  onFinish={handleRegister}
                  autoComplete="off"
                  layout="vertical"
                >
                  <Form.Item
                    label="用户名"
                    name="username"
                    rules={[
                      { required: true, message: '请输入用户名!' },
                      { min: 3, message: '用户名至少需要3个字符!' }
                    ]}
                  >
                    <Input 
                      prefix={<UserOutlined />} 
                      placeholder="请输入用户名" 
                      size="large" 
                    />
                  </Form.Item>

                  <Form.Item
                    label="密码"
                    name="password"
                    rules={[
                      { required: true, message: '请输入密码!' },
                      { min: 6, message: '密码至少需要6个字符!' }
                    ]}
                  >
                    <Input.Password 
                      prefix={<LockOutlined />} 
                      placeholder="请输入密码" 
                      size="large" 
                    />
                  </Form.Item>

                  <Form.Item
                    label="确认密码"
                    name="confirmPassword"
                    dependencies={['password']}
                    rules={[
                      { required: true, message: '请确认密码!' },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('password') === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error('两次输入的密码不一致!'));
                        },
                      }),
                    ]}
                  >
                    <Input.Password 
                      prefix={<LockOutlined />} 
                      placeholder="请再次输入密码" 
                      size="large" 
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button 
                      type="primary" 
                      htmlType="submit" 
                      block 
                      size="large"
                      className="auth-submit-btn"
                    >
                      注册
                    </Button>
                  </Form.Item>
                </Form>
              </Tabs.TabPane>
            </Tabs>
          </Card>
        </div>
      </Content>
      
      <AppFooter />
    </Layout>
  );
};

export default Auth;